<div class="reset-shop-class">
  <div class="header">
    <div class="header-content">Reset Store?</div>
    <img class="close-image" (click)="cancel()" src="./assets/icons/cancel.svg" />
  </div>
  <div class="content">
    <div class="line1">
      You're gonna reset <b>{{ data.storeName }}</b> store.
    </div>
    <div class="scan-select-form">
      @if (!isLoading) {
        <pdq-dropdown
          class="dropdown-orders"
          placeholder="Select Veify orders"
          [options]="posibbleVerifyOrders"
          selectBy="checked"
          staticListMaxHeight="400"
          maxWidth="670"
          [showClearSelectionOption]="true"
          (onMultiSelectChange)="changeVerifySelected($event)"
          [multiSelect]="true">
        </pdq-dropdown>
      }
      @if (!isLoading) {
        <pdq-dropdown
          class="dropdown-orders"
          placeholder="Select Assign orders"
          [options]="posibbleAssignOrders"
          selectBy="checked"
          staticListMaxHeight="400"
          maxWidth="670"
          [showClearSelectionOption]="true"
          (onMultiSelectChange)="changeAssignSelected($event)"
          [multiSelect]="true">
        </pdq-dropdown>
      }
    </div>
    <div class="line2">Are you sure?</div>
  </div>
  <div class="buttons">
    <div>
      <pdq-button label="Cancel" variant="light" (onClick)="cancel()"></pdq-button>
    </div>
    <div class="second-btn">
      <pdq-button label="Confirm" variant="primary" (onClick)="confirm()"></pdq-button>
    </div>
  </div>
</div>
